// import { WebCodeSend } from '@/apis/modules/uc'
// import { tencentCaptchaService } from '@/utils/TCaptchaService'
import { i18n } from '@/i18n/CMHKAuthorization'
import { vantLocales } from '@/i18n/startAccount'

const state = () => ({
    // 授权成功之后需要跳转的页面
    path: '',
    // mylink授权标识
    token: '',
    // 语言标识
    lang: '',
    // 是否判断开户
    open: 0,
    // 是否判断交易密码
    trade: 0,
    // token用户信息
    userInfo: {
        phone: '',
    },
})

const getters = {
    getPath(state) {
        return state.path
    },
    getToken(state) {
        return state.token
    },
    getLang(state) {
        return state.lang
    },
    getFlag(state) {
        return {
            open: state.open,
            trade: state.trade,
        }
    },
    getUserInfo(state) {
        return state.userInfo
    },
}

const langMap = {
    sc: 'zhCn',
    tc: 'zhTc',
    en: 'en',
}

const mutations = {
    setPath(state, path) {
        state.path = path
    },
    setToken(state, token) {
        state.token = token
    },
    setLang(state, lang) {
        state.lang = lang
    },
    setUserInfo(state, userInfo) {
        state.userInfo = { ...userInfo }
    },
    setOpen(state, open) {
        state.open = open
    },
    setTrade(state, trade) {
        state.trade = trade
    },
}

const actions = {
    updatePath({ commit }, path = '') {
        commit('setPath', path)
    },
    updateToken({ commit }, token = '') {
        commit('setToken', token)
    },
    updateLang({ commit, dispatch }, lang = 'zhCn') {
        const currLang = langMap[lang] || lang

        dispatch('app/setLang', currLang, { root: true })
        commit('setLang', currLang)

        i18n.locale = currLang
        vantLocales(currLang)
    },
    updateParams({ commit, dispatch }, { path = '', token = '', lang = 'zhCn', open = 0, trade = 0 } = {}) {
        commit('setPath', path)
        commit('setToken', token)
        commit('setOpen', open)
        commit('setTrade', trade)
        dispatch('updateLang', lang)
    },
    updateUserInfo({ commit }, userInfo = {}) {
        commit('setUserInfo', userInfo)
    },

    // 通用登录校验
    loginCheck(_store, { query = {}, tokenKey = 'thirdPartyToken', jump = true } = {}) {
        const { thirdPartyToken = '' } = query
        if (!thirdPartyToken) {
            console.warn('need token!')
            return [false]
        }

        const session = localStorage.getItem('session')
        const storedToken = localStorage.getItem(tokenKey)

        // (未登录 || 已登录但token更新) = 需要重新登录
        if (!session || (session && storedToken && thirdPartyToken !== storedToken)) {
            const queryStr = Object.entries(query)
                .reduce((str, [key, val]) => {
                    if (val) {
                        str += `&${key}=${val}`
                    }

                    return str
                }, '')
                .replace(/&/, '?')

            const jumpUrl = `/pages/CMHKAuthorization.html?t=${new Date().getTime()}#/${queryStr}`
            console.log('🚀 ~ go authorization page: ', jumpUrl)

            if (jump) {
                location.href = jumpUrl
            }

            return [false, jumpUrl]
        }

        return [true]
    },
}

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions,
}
